"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _reactPullToRefresh = _interopRequireDefault(require("react-pull-to-refresh"));

var _GameService = _interopRequireDefault(require("./services/GameService"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _index = _interopRequireDefault(require("../Button/index"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _Quiz = _interopRequireDefault(require("./Quiz.scss"));

var _QuizRoundOverview = _interopRequireDefault(require("./QuizRoundOverview.scss"));

var _QuizStrings = require("./QuizStrings");

var _QuizRoundOverviewStyle = require("./styles/QuizRoundOverviewStyle");

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _Constants = require("../../constants/Constants");

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _MessagingService = _interopRequireDefault(require("../../../KESI2/Services/MessagingService"));

var _QDGroupService = require("../../../KESI2/Services/QDGroupService");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _UserService = _interopRequireWildcard(require("./services/UserService"));

var _QuizTournament = require("./QuizTournament");

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _UserLogsService = _interopRequireDefault(require("./services/UserLogsService"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var ANSWERBOX_WIDTH_INCL_PADDING = 26;

var QuizRoundOverview = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(QuizRoundOverview, _DataStoreComponent);

  var _super = _createSuper(QuizRoundOverview);

  function QuizRoundOverview(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, QuizRoundOverview);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkIfGameComplete", function () {
      var currentRoundStates = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES);

      var currentGame = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GAME);

      console.log('QuizRoundOverview checkIfGameComplete', currentRoundStates, currentGame);

      if (currentRoundStates && currentRoundStates[currentGame.id] && currentRoundStates[currentGame.id].length === currentGame.questionsPerRound) {
        // check if we have a round that is already completed (because we chickened out at the last question -> wrong, but game was never sent)
        console.log('QuizRoundOverview checkIfGameComplete -> we have a game with 5 answers -> send it!', JSON.parse((0, _stringify["default"])(currentRoundStates[currentGame.id])));
        var roundQuestions = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS][_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].activeRound].questions;
        var questionIds = [];
        console.log('QuizRoundOverview checkIfGameComplete -> roundQuestions!', roundQuestions, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS], [_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].activeRound]);

        if (roundQuestions) {
          roundQuestions.forEach(function (question, index) {
            questionIds.push(question.id || index);
          }); // LOG: round start to end time

          _UserLogsService["default"].postRoundCompletionLog(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT].id, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].emsId, questionIds, _this.state.roundStartTime, (0, _now["default"])());

          var roundNumber = (_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS].length || 1) - 1;
          var playerState = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_PLAYERSTATE];
          _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].rounds[roundNumber].state[playerState] = JSON.parse((0, _stringify["default"])(currentRoundStates[currentGame.id]));
          currentRoundStates[currentGame.id] = [];

          _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES, currentRoundStates);

          console.log('QuizRoundOverview checkIfGameComplete -> we have a game with 5 answers -> send it! (updated game)', JSON.parse((0, _stringify["default"])(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME])));

          if (_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].activeRound === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].maxRounds - 1) {
            var gameTime = {
              start: new Date(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].dateCreated).getTime(),
              end: new Date(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].lastUpdatedOnDevice).getTime()
            }; // LOG: game start to end time

            _UserLogsService["default"].postGameCompletionLog(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].groupName, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT].id, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].emsId, gameTime.start, gameTime.end);
          }

          _this.props.onRoundComplete(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME]);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkForOtherRunningGames", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var userAuth, user, playgrouIdToUse, groupUsers, storedImages, groupUsersWithImage, okButton, cancelButton, runningGames, unfinishedUserGames, _okButton, playableGame, opponentData, _okButton2, _cancelButton, _groupUsers, tournamentData, maxConcurrentGames, teams, team1, team2, team1User, teamToCheck, playableUser, _okButton3, _cancelButton2;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.getAuthToken();

            case 2:
              userAuth = _context.sent;
              user = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER];
              playgrouIdToUse = user.playgroupId ? user.playgroupId : _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_ID);
              _context.next = 7;
              return _UserService["default"].getAllUsersAndLoadTheme(playgrouIdToUse, userAuth);

            case 7:
              groupUsers = _context.sent;

              if (!groupUsers) {
                _context.next = 15;
                break;
              }

              storedImages = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH];
              _context.next = 12;
              return _UserService["default"].getUserImages(groupUsers, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS], userAuth, storedImages);

            case 12:
              groupUsersWithImage = _context.sent;
              _context.next = 15;
              return _EquizzerActions["default"].setGroupUsers(groupUsersWithImage);

            case 15:
              console.log('checkForOtherRunningGames', _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME]);

              if (!(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].activePlayer === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id && !_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].finished)) {
                _context.next = 24;
                break;
              }

              if (!_this.playingDialog) {
                _context.next = 19;
                break;
              }

              return _context.abrupt("return");

            case 19:
              if (_this.waitingDialog) {
                _this.waitingDialog();
              }

              okButton = {
                label: (0, _QuizStrings.getString)('JUMP_TO_THE_GAME'),
                callback: function callback() {
                  var nextRoundAvaiable = _this.nextRoundAvailable(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME]);

                  if (nextRoundAvaiable === 1) {
                    _this.props.onChooseCategory(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME], true);
                  } else if (nextRoundAvaiable === 2) {
                    _this.props.onNextRound(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME], _this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT]);
                  }
                }
              };
              cancelButton = {
                label: (0, _QuizStrings.getString)('CANCEL'),
                callback: function callback() {
                  _this.playingDialog = null;
                }
              };
              _this.playingDialog = (0, _AlertHelper.showWideAlertHtml)((0, _QuizStrings.getString)('PLAY_NOW_TEXT_YOUR_TURN'), (0, _QuizStrings.getString)('PLAY_NOW_TITLE'), true, [okButton, cancelButton], true);
              return _context.abrupt("return");

            case 24:
              runningGames = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_ALL_GAME];
              unfinishedUserGames = runningGames.filter(function (game) {
                return !game.finished && game.hasOwnProperty('tournament') && (game.challenger === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id || game.opponent === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id);
              });
              console.log('unfinishedUserGames', runningGames, unfinishedUserGames);

              if (!((!unfinishedUserGames || unfinishedUserGames.length === 0) && _this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT].phase === _QuizTournament.TOURNAMENT_PHASES.WAIT_FOR_END)) {
                _context.next = 33;
                break;
              }

              clearInterval(_this.waitingInterval);

              if (_this.waitingDialog) {
                _this.waitingDialog();
              }

              _okButton = {
                label: (0, _QuizStrings.getString)('TO_QUIZ_HOME'),
                callback: function callback() {
                  _NavigationManager["default"].goToQuizHome(_this.props.tournamentMode);
                }
              };
              _this.waitingDialog = (0, _AlertHelper.showWideAlertHtml)((0, _QuizStrings.getString)('TOURNAMENT_FINISHED_TEXT_NOT_FINISHED'), (0, _QuizStrings.getString)('TOURNAMENT_FINISHED_TITLE'), false, [_okButton]);
              return _context.abrupt("return");

            case 33:
              playableGame = null;
              runningGames.forEach(function (game) {
                if (game.activePlayer === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id && game.hasOwnProperty('tournament') && game.id !== _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].id && !game.finished) {
                  if (playableGame) {
                    var currentPlayableGameLastUpdated = new Date(playableGame.lastUpdated).getTime();
                    var gameLastUpdated = new Date(game.lastUpdated).getTime();

                    if (currentPlayableGameLastUpdated > gameLastUpdated) {
                      playableGame = game;
                    }
                  } else {
                    playableGame = game;
                  }
                }
              });

              if (!playableGame) {
                _context.next = 45;
                break;
              }

              if (!_this.playingDialog) {
                _context.next = 38;
                break;
              }

              return _context.abrupt("return");

            case 38:
              if (_this.waitingDialog) {
                _this.waitingDialog();
              }

              if (playableGame.challenger === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
                opponentData = _this.getUserDataById(playableGame.opponent);
              } else {
                opponentData = _this.getUserDataById(playableGame.challenger);
              }

              _okButton2 = {
                label: (0, _QuizStrings.getString)('JUMP_TO_THE_GAME'),
                callback: function callback() {
                  _this.playingDialog = null;

                  _this.changeGame(playableGame, opponentData);
                }
              };
              _cancelButton = {
                label: (0, _QuizStrings.getString)('CANCEL'),
                callback: function callback() {
                  _this.playingDialog = null;
                }
              };
              _this.playingDialog = (0, _AlertHelper.showWideAlertHtml)((0, _QuizStrings.getString)('PLAY_NOW_TEXT', [opponentData.nickname]), (0, _QuizStrings.getString)('PLAY_NOW_TITLE'), false, [_okButton2, _cancelButton], true);
              _context.next = 62;
              break;

            case 45:
              _groupUsers = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS];
              tournamentData = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT];
              maxConcurrentGames = tournamentData.concurrentGamesPerUser;
              teams = (0, _values["default"])(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT]['teams']);
              team1 = teams[0];
              team2 = teams[1];
              team1User = team1.members.find(function (user) {
                return user.id === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id;
              });
              teamToCheck = team1User ? team2 : team1;
              playableUser = null;
              teamToCheck.members.forEach(function (userObj) {
                var user = _groupUsers.find(function (user) {
                  return user.id === userObj.id;
                });

                if (!user || user.id === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
                  return;
                }

                var userGame = user.game ? runningGames.find(function (game) {
                  return game.id === user.game && game.hasOwnProperty('tournament');
                }) : null; // Wenn es kein usergame gibt oder
                // Wenn es ein beendetes Usergame gibt oder
                // Wenn das aktuelle Spiel beendet ist und es kein userGame gibt

                if ((!userGame || userGame.finished) && tournamentData.phase === _QuizTournament.TOURNAMENT_PHASES.PLAY_GAMES) {
                  if (maxConcurrentGames && maxConcurrentGames > user.openGamesCount) {
                    console.log("setting user ".concat(user.nickname, " as playable user because he has no game with the current user and user has less than ").concat(maxConcurrentGames, " games"), _groupUsers);
                    playableUser = user;
                  } else {
                    console.log("setting user ".concat(user.nickname, " as playable user because he has no game with the current user"), _groupUsers);
                    playableUser = user;
                  }
                }
              });

              if (!playableUser) {
                _context.next = 62;
                break;
              }

              if (!_this.playingDialog) {
                _context.next = 58;
                break;
              }

              return _context.abrupt("return");

            case 58:
              if (_this.waitingDialog) {
                _this.waitingDialog();
              }

              _okButton3 = {
                label: (0, _QuizStrings.getString)('JUMP_TO_THE_GAME'),
                callback: function callback() {
                  _this.checkOpponent(playableUser);
                }
              };
              _cancelButton2 = {
                label: (0, _QuizStrings.getString)('CANCEL'),
                callback: function callback() {
                  _this.playingDialog = null;
                }
              };
              _this.playingDialog = (0, _AlertHelper.showWideAlertHtml)((0, _QuizStrings.getString)('PLAY_NOW_TEXT', [playableUser.nickname]), (0, _QuizStrings.getString)('PLAY_NOW_TITLE'), false, [_okButton3, _cancelButton2], true);

            case 62:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkOpponent", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(playableUser) {
        var userAuth, user, playgrouIdToUse, groupUsers, storedImages, groupUsersWithImage, _updatedUser, games, userGame;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.props.getAuthToken();

              case 2:
                userAuth = _context2.sent;
                user = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER];
                playgrouIdToUse = user.playgroupId ? user.playgroupId : _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_ID);
                _context2.next = 7;
                return _UserService["default"].getAllUsersAndLoadTheme(playgrouIdToUse, userAuth);

              case 7:
                groupUsers = _context2.sent;

                if (!groupUsers) {
                  _context2.next = 16;
                  break;
                }

                storedImages = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH];
                _context2.next = 12;
                return _UserService["default"].getUserImages(groupUsers, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS], userAuth, storedImages);

              case 12:
                groupUsersWithImage = _context2.sent;
                _context2.next = 15;
                return _EquizzerActions["default"].setGroupUsers(groupUsersWithImage);

              case 15:
                _updatedUser = groupUsers.find(function (user) {
                  return user.id === playableUser.id;
                });

              case 16:
                _context2.next = 18;
                return _GameService["default"].loadAllGame(userAuth);

              case 18:
                games = _context2.sent;
                _context2.next = 21;
                return _EquizzerActions["default"].setAllGame(games);

              case 21:
                userGame = updatedUser.game ? games.find(function (game) {
                  return game.id === updatedUser.game && game.hasOwnProperty('tournament');
                }) : null;

                if (!userGame || userGame.activePlayer === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
                  _this.playingDialog = null;

                  _this.props.onSetOpponent(updatedUser);
                } else {
                  _this.playingDialog = null;
                  (0, _AlertHelper.showAlertWithOptions)({
                    html: (0, _ErrorHelper.getErrorMessage)('always running game present'),
                    title: (0, _QuizStrings.getString)('FAILURE'),
                    centeredContent: true,
                    showCloseButton: false
                  });
                }

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeGame", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(game, opponent) {
        var _UserService$getPlaye, userData, selectedOpponentData, nextRoundAvailable;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _EquizzerActions["default"].updateGame(game);

              case 2:
                // get the player state (challenger or opponent)
                _UserService$getPlaye = _UserService["default"].getPlayerState(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER], opponent, game), userData = _UserService$getPlaye.userData, selectedOpponentData = _UserService$getPlaye.selectedOpponentData; // update logged in player's game state

                _context3.next = 5;
                return _EquizzerActions["default"].setUser(userData, 'QuizRoundOverview');

              case 5:
                _context3.next = 7;
                return _EquizzerActions["default"].setUserPoints(userData.points);

              case 7:
                _context3.next = 9;
                return _EquizzerActions["default"].setOpponent(selectedOpponentData);

              case 9:
                if (game.challenger === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
                  _this.setState({
                    playerState: 'challenger'
                  });
                } else {
                  _this.setState({
                    playerState: 'opponent'
                  });
                }

                nextRoundAvailable = _this.nextRoundAvailable(game);

                if (nextRoundAvailable === 1) {
                  _this.props.onChooseCategory(game, true);
                } else if (nextRoundAvailable === 2) {
                  _this.props.onNextRound(game, opponent);
                }

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserDataById", function (userId) {
      console.log('getUserDataById', userId);
      var opponents = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_OPPONENTS];
      var opponentData = opponents.find(function (opponent) {
        return opponent.id === userId;
      });

      if (opponentData) {
        return opponentData;
      }

      return null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onPresenceChange", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var groupId, channelName, presentUsers;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              groupId = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_ID];
              channelName = (0, _QDGroupService.getChannelName)(groupId);
              _context4.next = 4;
              return _MessagingService["default"].getPresence(channelName);

            case 4:
              presentUsers = _context4.sent;
              presentUsers.forEach(function (userPresence) {
                if (userPresence.data.opponent === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id && userPresence.data.nickname === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT_NICKNAME]) {
                  if (userPresence.data && userPresence.data.round !== null && userPresence.data.question !== null) {
                    _this.setState({
                      currentOpponentRound: userPresence.data.round,
                      currentOpponentQuestion: userPresence.data.question
                    });
                  } else {
                    _this.setState({
                      currentOpponentRound: null,
                      currentOpponentQuestion: null
                    });
                  }
                }
              });

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserPlayerState", function () {
      _this.setState({
        playerState: _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].playerState
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "pullToRefresh", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(resolve, reject) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this.state.currentlyUpdating) {
                  reject();
                } else {
                  _this.updateCurrentGame();

                  resolve();
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x4, _x5) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onStartPullingToRefresh", function () {
      if (!_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].finished) {
        _this.isPullingToRefresh = true;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onStopPullingToRefresh", function () {
      if (!_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].finished) {
        setTimeout(function () {
          if (!_this.currentlyUpdating) {
            _this.isPullingToRefresh = false;
          }
        }, 500); // wait some to let the part go back upwards
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "calculatefeedbackIconTop", function () {
      if (_this.state.feedbackIconTop === 0) {
        console.log('calculateFeedbackIconTop');
        var scoreButton = document.getElementById('scoreCircle1');
        var scoreButtonRect = scoreButton.getBoundingClientRect();
        console.log('calculateFeedbackIconTop', scoreButtonRect.top);
        var top = scoreButtonRect.top;

        if (CSS.supports('padding-bottom: constant(safe-area-inset-top)')) {
          var div = document.createElement('div');
          div.style.paddingTop = 'constant(safe-area-inset-top)';
          document.body.appendChild(div);
          var calculatedPadding = (0, _parseInt2["default"])(window.getComputedStyle(div).paddingTop, 10);
          document.body.removeChild(div);
          var valueToReturn = _cssConstants["default"].safeAreaTopDivisor ? calculatedPadding / _cssConstants["default"].safeAreaTopDivisor : calculatedPadding;
          top -= valueToReturn;
        }

        if (CSS.supports('padding-bottom: env(safe-area-inset-top)')) {
          var _div = document.createElement('div');

          _div.style.paddingTop = 'env(safe-area-inset-top)';
          document.body.appendChild(_div);

          var _calculatedPadding = (0, _parseInt2["default"])(window.getComputedStyle(_div).paddingTop, 10);

          document.body.removeChild(_div);

          var _valueToReturn = _cssConstants["default"].safeAreaTopDivisor ? _calculatedPadding / _cssConstants["default"].safeAreaTopDivisor : _calculatedPadding;

          top -= _valueToReturn;
        }

        _this.setState({
          feedbackIconTop: top
        });
      }
    });
    _this.state = {
      playerState: '',
      category: '',
      currentOpponentRound: null,
      currentOpponentQuestion: null,
      feedbackIconTop: 0
    };
    _this.waitingInterval = null;
    _this.playingDialog = null;
    _this.waitingDialog = null;
    _this.currentlyUpdating = false;
    _this.isPullingToRefresh = false;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizRoundOverview.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_ALL_GAME, _DataStore.DATA_STORE_PATHS.QD_GAME, _DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS, _DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT, _DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_LEAGUE_NAME, _DataStore.DATA_STORE_PATHS.QD_USER_NICKNAME, _DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT_NICKNAME, _DataStore.DATA_STORE_PATHS.QD_USER_PICTURE, _DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT_PICTURE, _DataStore.DATA_STORE_PATHS.QD_GROUP_ID, _DataStore.DATA_STORE_PATHS.QD_OPPONENTS, _DataStore.DATA_STORE_PATHS.QD_GROUP_USERS, _DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK, _DataStore.DATA_STORE_PATHS.QD_USER_PLAYERSTATE]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizRoundOverview.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'quiz']
    }]);
    return _this;
  }
  /*
  componentWillMount () {
    //super.componentWillMount()
    this.getLastLocation()
  }
  */


  (0, _createClass2["default"])(QuizRoundOverview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.calculatefeedbackIconTop();
      this.props.setTitle((0, _QuizStrings.getString)('OVERVIEW'));
      this.getUserPlayerState();

      if (!_config["default"].disableQuizPolling) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = setInterval( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
          return _regenerator["default"].wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!_this2.currentlyUpdating) {
                    _this2.updateCurrentGame();
                  }

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        })), 30000);
      }

      if (this.props.tournamentMode) {
        clearInterval(this.waitingInterval);
        this.waitingInterval = setInterval(function () {
          _this2.checkForOtherRunningGames();
        }, _Constants.TOURNAMENT_WARNING_TIMEOUT);
      }

      var groupId = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_ID];
      (0, _QDGroupService.subscribeQDPresence)(groupId, this.onPresenceChange);
      this.onPresenceChange();
      this.checkIfGameComplete();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.waitingInterval);
      clearInterval(this.pollingInterval);
      console.log('quizroundoverview all timers cleared');
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(QuizRoundOverview.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "renderSequenceBackgrounds",
    value: function renderSequenceBackgrounds(questions) {
      var currentSequenceId = null;
      var currentSequenceBegin = null;
      var sequenceBackgrounds = questions.reduce(function (acc, question, index) {
        // if (index === 0 || index === 1) {
        //   question.sequence = '_sequence_'
        // }
        // if (index === 2 || index === 3) {
        //   question.sequence = '_sequence2_'
        // }
        var returnValue = acc;

        if (currentSequenceId !== question.sequence) {
          if (currentSequenceId) {
            var sequenceLength = index - currentSequenceBegin;
            returnValue.push( /*#__PURE__*/_react["default"].createElement("div", {
              key: question.sequence,
              className: _QuizRoundOverview["default"].sequenceOuter
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _QuizRoundOverview["default"].sequence,
              style: {
                width: (index - currentSequenceBegin) * ANSWERBOX_WIDTH_INCL_PADDING,
                left: "calc(50% + ".concat(currentSequenceBegin * ANSWERBOX_WIDTH_INCL_PADDING - (questions.length - sequenceLength) / 2 * ANSWERBOX_WIDTH_INCL_PADDING, "px)")
              }
            })));
            currentSequenceId = null;
            currentSequenceBegin = null;
          }

          if (question.sequence) {
            currentSequenceId = question.sequence;
            currentSequenceBegin = index;
          }
        } // add block if this was the last question and there is still an open block left


        if (index === questions.length - 1 && currentSequenceBegin !== null) {
          var _sequenceLength = questions.length - currentSequenceBegin;

          returnValue.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: question.sequence,
            className: _QuizRoundOverview["default"].sequenceOuter
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _QuizRoundOverview["default"].sequence,
            style: {
              width: (index - currentSequenceBegin + 1) * ANSWERBOX_WIDTH_INCL_PADDING,
              // right: (questions.length - index) * 26 + paddingRight,
              left: "calc(50% + ".concat(currentSequenceBegin * ANSWERBOX_WIDTH_INCL_PADDING - (questions.length - _sequenceLength) / 2 * ANSWERBOX_WIDTH_INCL_PADDING, "px)")
            }
          })));
        }

        return returnValue;
      }, []);
      return sequenceBackgrounds;
    }
  }, {
    key: "updateCurrentGame",
    value: function () {
      var _updateCurrentGame = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var _this3 = this;

        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log('quiz round overview, update current game');

                if (!this.currentlyUpdating) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return");

              case 3:
                this.currentlyUpdating = true;

                if (!(!this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].finished && this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].activePlayer !== this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id)) {
                  _context7.next = 25;
                  break;
                }

                _context7.prev = 5;
                _context7.t0 = _GameService["default"];
                _context7.t1 = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].id;
                _context7.next = 10;
                return this.props.getAuthToken();

              case 10:
                _context7.t2 = _context7.sent;
                _context7.next = 13;
                return _context7.t0.loadCurrentGame.call(_context7.t0, _context7.t1, _context7.t2);

              case 13:
                response = _context7.sent;

                if (!(response && (response.rounds && this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].rounds[this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].rounds.length - 1].actionState !== response.rounds[response.rounds.length - 1].actionState || response.finished === true))) {
                  _context7.next = 18;
                  break;
                }

                _context7.next = 17;
                return _EquizzerActions["default"].updateGame(response);

              case 17:
                if (this.props.tournamentMode) {
                  clearInterval(this.waitingInterval);

                  if (this.waitingDialog) {
                    this.waitingDialog();
                  }

                  this.waitingInterval = setInterval(function () {
                    _this3.checkForOtherRunningGames();
                  }, _Constants.TOURNAMENT_WARNING_TIMEOUT);
                }

              case 18:
                _context7.next = 23;
                break;

              case 20:
                _context7.prev = 20;
                _context7.t3 = _context7["catch"](5);
                console.log(_context7.t3);

              case 23:
                _context7.next = 26;
                break;

              case 25:
                clearInterval(this.pollingInterval);

              case 26:
                this.currentlyUpdating = false;
                this.isPullingToRefresh = false;

              case 28:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[5, 20]]);
      }));

      function updateCurrentGame() {
        return _updateCurrentGame.apply(this, arguments);
      }

      return updateCurrentGame;
    }()
  }, {
    key: "nextRoundAvailable",
    value: function nextRoundAvailable(game) {
      var latestRoundNumber = game.rounds.length - 1; // return -1 if game is dirty -> game on client is newer than on the server, wait for post to go through
      // return 0 if no next round
      // return 1 if next round && choose Category
      // return 2 if next round && no choose Category

      if (game.isDirty) {
        return -1;
      }

      if (this.state.playerState === 'challenger' && game.rounds[latestRoundNumber].actionState === 'challengerMustAnswer' && !game.finished || this.state.playerState === 'opponent' && game.rounds[latestRoundNumber].actionState === 'opponentMustAnswer' && !game.finished) {
        return 2;
      } else if (game.rounds[latestRoundNumber].actionState === 'chooseCategory' && game.activePlayer === this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
        return 1;
      }

      return 0;
    }
  }, {
    key: "prepareAnswerStateHTML",
    value: function prepareAnswerStateHTML(round, answerState,
    /* answerStateHTML, */
    totalQuestions, dynamicStyles, isUser) {
      var sequenceCounter = {};
      var sequenceCorrect = {}; // add all points of questions not in a sequence

      if (round && round.questions) {
        round.questions.forEach(function (question) {
          var questionInRound = answerState[question.number];

          if (questionInRound && questionInRound.score > 0) {
            if (question.sequence) {
              if (!sequenceCounter[question.sequence]) {
                sequenceCounter[question.sequence] = 1;
              } else {
                sequenceCounter[question.sequence] += 1;
              }
            }
          }
        }); // now check if enough questions were answered correctly in the sequences and add sequence points then

        (0, _keys["default"])(sequenceCounter).forEach(function (sequenceName) {
          var sequenceDefinition = round.sequences[sequenceName];

          if (sequenceDefinition) {
            sequenceCorrect[sequenceName] = sequenceCounter[sequenceName] >= sequenceDefinition.correctlyAnsweredMin;
          }
        });
      }

      var answerStateHTML = '<div style="position: relative">';

      var checkIcon = _server["default"].renderToString( /*#__PURE__*/_react["default"].createElement(_Done["default"], {
        className: _QuizRoundOverview["default"].icon
      }));

      var wrongIcon = _server["default"].renderToString( /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        className: _QuizRoundOverview["default"].icon
      }));

      if (answerState.length < 0) {
        for (var i = 0; i < totalQuestions; i++) {
          answerStateHTML += "<div class=\"".concat(this.state.currentOpponentRound === round.number && i + 1 === this.state.currentOpponentQuestion && !isUser ? _QuizRoundOverview["default"].answerStatusContainerJumping : _QuizRoundOverview["default"].answerStatusContainer, "\"><div class=\"").concat(_QuizRoundOverview["default"].answerStatus, "\">"); // answerStateHTML += '<div class="' + ownStyles.answerStatusContainer + '"><div class="'+ ownStyles.answerStatus +'">';

          answerStateHTML += "<div style=\"color: rgba(0,0,0,0); background-color: ".concat(dynamicStyles.neutralStyle.backgroundColor, ";\" class=\"").concat(_QuizRoundOverview["default"].correct, "\">").concat(checkIcon, "</div>"); // answerStateHTML += '<span style="color: rgba(0,0,0,0); background-color: '+dynamicStyles.wrongStyle.backgroundColor+';" class="'+ ownStyles.correct +' genericon genericon-checkmark"></span>';

          answerStateHTML += '</div></div>';
        }
      }

      if (round && round.questions) {
        for (var _i = 0; _i < answerState.length; _i++) {
          var hideFeedbackByGroup = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK];
          var isSequenceAndIncorrect = Boolean(round.questions[_i].sequence) && !sequenceCorrect[round.questions[_i].sequence];
          answerStateHTML += "<div class=\"".concat(_QuizRoundOverview["default"].answerStatusContainer, "\" ><div class=\"").concat(_QuizRoundOverview["default"].answerStatus, "\">"); // answerStateHTML += '<div class="' + ownStyles.answerStatusContainer + '"><div class="'+ ownStyles.answerStatus +'">';

          if (!hideFeedbackByGroup) {
            answerStateHTML += answerState[_i].score ? "<div style=\"opacity: ".concat(isSequenceAndIncorrect ? '0.5' : '1', "; color: ").concat(dynamicStyles.correctStyle.color, "; background-color: ").concat(dynamicStyles.correctStyle.backgroundColor, ";\" class=\"").concat(_QuizRoundOverview["default"].correct, "\">").concat(checkIcon, "</div>") : "<div style=\"opacity: ".concat(isSequenceAndIncorrect ? '0.5' : '1', "; color: ").concat(dynamicStyles.wrongStyle.color, "; background-color: ").concat(dynamicStyles.wrongStyle.backgroundColor, ";\" class=\"").concat(_QuizRoundOverview["default"].wrong, "\">").concat(wrongIcon, "</div>");
          } else {
            answerStateHTML += "<div style=\"color: ".concat(dynamicStyles.neutralStyle.color, "; background-color: ").concat(dynamicStyles.neutralStyle.backgroundColor, ";\" class=\"").concat(_QuizRoundOverview["default"].wrong, "\">").concat(_i + 1, "</div>");
          } // answerStateHTML += answerState[i].score ? '<span style="color: '+dynamicStyles.correctStyle.color+'; background-color: '+dynamicStyles.correctStyle.backgroundColor+';" class="'+ ownStyles.correct +' genericon genericon-checkmark"></span>' :
          // '<span style="color: '+dynamicStyles.wrongStyle.color+'; background-color: '+dynamicStyles.wrongStyle.backgroundColor+';" class="'+ ownStyles.wrong +' genericon genericon-close"></span>';


          answerStateHTML += '</div></div>';
        }
      }

      if (answerState.length < totalQuestions) {
        for (var _i2 = answerState.length; _i2 < totalQuestions; _i2++) {
          answerStateHTML += "<div class=\"".concat(this.state.currentOpponentRound === round.number && _i2 + 1 === this.state.currentOpponentQuestion && !isUser ? _QuizRoundOverview["default"].answerStatusContainerJumping : _QuizRoundOverview["default"].answerStatusContainer, "\"><div class=\"").concat(_QuizRoundOverview["default"].answerStatus, "\">"); // answerStateHTML += '<div class="' + ownStyles.answerStatusContainer + '"><div class="'+ ownStyles.answerStatus +'">';

          answerStateHTML += "<div style=\"color: rgba(0,0,0,0); background-color: ".concat(dynamicStyles.neutralStyle.backgroundColor, ";\" class=\"").concat(_QuizRoundOverview["default"].correct, "\">").concat(checkIcon, "</div>"); // answerStateHTML += '<span style="color: rgba(0,0,0,0); background-color: '+dynamicStyles.wrongStyle.backgroundColor+';" class="'+ ownStyles.correct +' genericon genericon-checkmark"></span>';

          answerStateHTML += '</div></div>';
        }
      } // if (this.state.currentOpponentRound === round.number && !isUser) {
      //   answerStateHTML += '<div style="font-size: 12px; position: absolute; top: 30px; width: 100%;">Dein Gegner spielt</div>'
      // }


      answerStateHTML += '</div>';
      return answerStateHTML;
    }
  }, {
    key: "getScreenRatio",
    value: function getScreenRatio() {
      //    const height = window.screen.height - NAVBAR_HEIGHT
      //    const width = window.screen.width
      var height = window.innerHeight - _Constants.NAVBAR_HEIGHT;
      var width = window.innerWidth;
      return height / width;
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(scores, styles) {
      var style = _DeviceInfoHelper["default"].isBrowser() ? {
        fontSize: '80px',
        position: 'relative',
        top: '30%',
        transform: 'translateY(100%)'
      } : {
        fontSize: '80px',
        position: 'relative',
        top: '30%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].headerContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].header
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].columns,
        style: (0, _QuizRoundOverviewStyle.getLoggedInUserStyle)(this.state, 'challenger').userStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].userName,
        style: styles.userNameStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].thumb
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "img",
        src: this.state.playerState === 'challenger' ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_PICTURE] ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_PICTURE] : _UserService.DEFAULT_IMAGE : this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT_PICTURE] ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT_PICTURE] : _UserService.DEFAULT_IMAGE
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].userNameText
      }, this.state.playerState === 'challenger' ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_NICKNAME] : this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT_NICKNAME])), /*#__PURE__*/_react["default"].createElement("div", {
        id: "scoreCircle1",
        className: _QuizRoundOverview["default"].score,
        style: _config["default"].useNewScoreStyle ? scores.player1Score >= scores.player2Score ? styles.correctStyle : styles.wrongStyle : styles.scoreStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].scoreText
      }, scores.player1Score), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].scoreInfo
      }, scores.player1Score === 1 ? 'Punkt' : 'Punkte'))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_QuizRoundOverview["default"].columns, " ").concat(_QuizRoundOverview["default"].midColumn),
        style: styles.midColumnStyle
      }, /*#__PURE__*/_react["default"].createElement("p", {
        style: style
      }, "\xA0")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].columns,
        style: (0, _QuizRoundOverviewStyle.getLoggedInUserStyle)(this.state, 'opponent').userStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].userName,
        style: styles.userNameStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].thumb
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "img",
        src: this.state.playerState !== 'challenger' ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_PICTURE] ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_PICTURE] : _UserService.DEFAULT_IMAGE : this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT_PICTURE] ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT_PICTURE] : _UserService.DEFAULT_IMAGE
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].userNameText
      }, this.state.playerState !== 'challenger' ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_NICKNAME] : this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT_NICKNAME])), /*#__PURE__*/_react["default"].createElement("div", {
        id: "scoreCircle2",
        className: _QuizRoundOverview["default"].score,
        style: _config["default"].useNewScoreStyle ? scores.player2Score >= scores.player1Score ? styles.correctStyle : styles.wrongStyle : styles.scoreStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].scoreText
      }, scores.player2Score), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].scoreInfo
      }, scores.player2Score === 1 ? 'Punkt' : 'Punkte')))));
    }
  }, {
    key: "renderFooter",
    value: function renderFooter(deviceRatio) {
      var _this4 = this;

      var footerClass = deviceRatio < _Constants.SMALL_DEVICE_RATIO && deviceRatio > _Constants.LANDSCAPE_RATIO ? _QuizRoundOverview["default"].smallFixedFooter : _QuizRoundOverview["default"].fixedFooter;
      var nextRoundAvailable = this.nextRoundAvailable(this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME]);
      return (
        /*#__PURE__*/
        // return -1 if game is dirty -> game on client is newer than on the server, wait for post to go through
        // return 0 if no next round
        // return 1 if next round && choose Category
        // return 2 if next round && no choose Category
        _react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: footerClass
        }, nextRoundAvailable === -1 && /*#__PURE__*/_react["default"].createElement(_index["default"], {
          className: "".concat(_QuizRoundOverview["default"].button, " button"),
          onClick: function onClick() {
            return _this4.props.onGoHome();
          },
          theme: this.state.currentTheme
        }, (0, _QuizStrings.getString)('NEXT')), nextRoundAvailable === 0 && this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].finished && /*#__PURE__*/_react["default"].createElement(_index["default"], {
          className: "".concat(_QuizRoundOverview["default"].button, " button"),
          onClick: function onClick() {
            return _this4.props.onSetOpponent(_this4.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT]);
          },
          theme: this.state.currentTheme
        }, (0, _QuizStrings.getString)('REVANCHE')), nextRoundAvailable === 0 && !this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].finished && /*#__PURE__*/_react["default"].createElement(_index["default"], {
          className: "".concat(_QuizRoundOverview["default"].button, " button"),
          onClick: function onClick() {
            return _this4.props.onGoHome();
          },
          theme: this.state.currentTheme
        }, (0, _QuizStrings.getString)('NEXT')), nextRoundAvailable === 1 && this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].game_status !== 0 && /*#__PURE__*/_react["default"].createElement(_index["default"], {
          className: "".concat(_QuizRoundOverview["default"].button, " button"),
          onClick: function onClick() {
            return _this4.props.onChooseCategory(_this4.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME], true);
          },
          theme: this.state.currentTheme
        }, (0, _QuizStrings.getString)('OVERVIEW_CHOOSE_CATEGORY')), nextRoundAvailable === 1 && this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].game_status === 0 && this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].rounds && this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].rounds.length > 1 && /*#__PURE__*/_react["default"].createElement(_index["default"], {
          className: "".concat(_QuizRoundOverview["default"].button, " button"),
          onClick: function onClick() {
            return _this4.props.onChooseCategory(_this4.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME], true);
          },
          theme: this.state.currentTheme
        }, (0, _QuizStrings.getString)('OVERVIEW_CHOOSE_CATEGORY')), nextRoundAvailable === 1 && this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].game_status === 0 && this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].rounds && this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].rounds.length <= 1 && /*#__PURE__*/_react["default"].createElement(_index["default"], {
          className: "".concat(_QuizRoundOverview["default"].button, " button"),
          onClick: function onClick() {
            return _this4.props.onChooseCategory(_this4.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME], true);
          },
          theme: this.state.currentTheme
        }, (0, _QuizStrings.getString)('OVERVIEW_CHOOSE_CATEGORY')), nextRoundAvailable === 2 && /*#__PURE__*/_react["default"].createElement(_index["default"], {
          className: "".concat(_QuizRoundOverview["default"].button, " button"),
          onClick: function onClick() {
            return _this4.props.onNextRound(_this4.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME], _this4.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT]);
          },
          theme: this.state.currentTheme
        }, (0, _QuizStrings.getString)('OVERVIEW_PLAY_ROUND'))))
      );
    }
  }, {
    key: "renderFinalStatus",
    value: function renderFinalStatus(scores) {
      var hideFeedbackByGroup = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK);

      if (hideFeedbackByGroup) {
        return null;
      }

      var overlayStyles = (0, _QuizRoundOverviewStyle.getOverlayIconStyles)(this.state);
      var userScore = scores.player1Score;
      var opponentScore = scores.player2Score;
      var feedbackPosition = {
        top: "".concat(this.state.feedbackIconTop, "px")
      };

      if (this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id !== this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].challenger) {
        userScore = scores.player2Score;
        opponentScore = scores.player1Score;
      }

      var gameResult = {
        text: (0, _QuizStrings.getString)('TIE'),
        textLeague: (0, _QuizStrings.getString)('TIE_LEAGUE'),
        style: overlayStyles.correct,
        icon: 'thumbs-up'
      };

      if (userScore > opponentScore) {
        gameResult.text = (0, _QuizStrings.getString)('WON');
        gameResult.textLeague = (0, _QuizStrings.getString)('WON_LEAGUE');
        gameResult.style = overlayStyles.correct;
      } else if (userScore < opponentScore) {
        gameResult.text = (0, _QuizStrings.getString)('LOST');
        gameResult.textLeague = (0, _QuizStrings.getString)('LOST_LEAGUE');
        gameResult.style = overlayStyles.wrong;
        gameResult.icon = 'thumbs-down';
      }

      return /*#__PURE__*/_react["default"].createElement("p", {
        className: "".concat(_config["default"].showMinimalizedFeedbackIcon ? _QuizRoundOverview["default"].smallFeedbackOverlayIcon : _QuizRoundOverview["default"].feedbackOverlayIcon, " ").concat(this.state.data[_DataStore.DATA_STORE_PATHS.QD_LEAGUE_NAME] ? _QuizRoundOverview["default"].leagueMode : ''),
        style: (0, _assign["default"])(gameResult.style, feedbackPosition)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].innerFeedbackContainer
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: gameResult.icon,
        style: {
          fontSize: 50,
          marginTop: 6
        }
      }), _config["default"].showMinimalizedFeedbackIcon ? null : /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("br", null), gameResult.text), this.state.data[_DataStore.DATA_STORE_PATHS.QD_LEAGUE_NAME] ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].text_league
      }, gameResult.textLeague) : null));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (!this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME]) {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      }

      var dynamicStyles = (0, _QuizRoundOverviewStyle.getStyles)(this.state);
      var ratio = this.getScreenRatio();

      var scores = _GameService["default"].calculateScore(this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS]);

      var columnPaddingStyle = {
        padding: '5% 0'
      };
      var rounds = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS];
      var maxRounds = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].maxRounds || 5;

      for (var i = rounds.length; i < maxRounds; i++) {
        rounds = rounds.concat({
          number: i
        });
      }

      var totalQuestions = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].questionsPerRound || 5;
      var currentRound = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].activeRound;
      var roundsDisplayed = rounds.map(function (round, index) {
        // prepare HTML for player1 answer state
        var currentRoundStates = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES);

        var currentGame = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GAME);

        var player1State = round.state ? round.state.challenger : [];

        if (_this5.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].challenger === _this5.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id && player1State.length < totalQuestions && currentRoundStates && currentRoundStates[currentGame.id] && currentRound === index) {
          if (currentRoundStates && currentRoundStates[currentGame.id]) {
            console.log('player1State currentRoundState', currentRoundStates[currentGame.id]);
            player1State = currentRoundStates[currentGame.id];
          }
        }

        var player1StateHTML = _this5.prepareAnswerStateHTML(round, player1State, totalQuestions, dynamicStyles, _this5.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].challenger === _this5.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id); // prepare HTML for player2 answer state


        var player2State = round.state ? round.state.opponent : [];

        if (_this5.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].opponent === _this5.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id && player2State.length < totalQuestions && currentRoundStates && currentRoundStates[currentGame.id] && currentRound === index) {
          if (currentRoundStates && currentRoundStates[currentGame.id]) {
            console.log('player2State currentRoundState', currentRoundStates[currentGame.id]);
            player2State = currentRoundStates[currentGame.id];
          }
        }

        var player2StateHTML = _this5.prepareAnswerStateHTML(round, player2State, totalQuestions, dynamicStyles, _this5.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].opponent === _this5.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id);

        var questions = round.questions;
        var sequence = null;

        if (questions && questions.length > 0) {
          sequence = _this5.renderSequenceBackgrounds(questions);
        }

        var className = _DeviceInfoHelper["default"].isBrowser() ? round.number === maxRounds - 1 ? _QuizRoundOverview["default"].lastRowBrowser : _QuizRoundOverview["default"].rowBrowser : round.number === maxRounds - 1 ? _QuizRoundOverview["default"].lastRow : _QuizRoundOverview["default"].row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "round_overview_".concat(round.number),
          className: className
        }, /*#__PURE__*/_react["default"].createElement("div", {
          onTouchStart: _this5.onStartPullingToRefresh,
          onTouchEnd: _this5.onStopPullingToRefresh
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizRoundOverview["default"].columns,
          style: (0, _assign["default"])((0, _QuizRoundOverviewStyle.getLoggedInUserStyle)(_this5.state, 'challenger', index).userStyle, columnPaddingStyle)
        }, player1State.length > 0 && sequence, /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizRoundOverview["default"].answerContainer,
          dangerouslySetInnerHTML: {
            __html: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(player1StateHTML)
          }
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_QuizRoundOverview["default"].columns, " ").concat(_QuizRoundOverview["default"].midColumn, " ").concat(_this5.props.runsInKesi ? _QuizRoundOverview["default"].inKesi : ''),
          style: dynamicStyles.midColumnStyle
        }, index + 1), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizRoundOverview["default"].columns,
          style: (0, _assign["default"])((0, _QuizRoundOverviewStyle.getLoggedInUserStyle)(_this5.state, 'opponent', index).userStyle, columnPaddingStyle)
        }, player2State.length > 0 && sequence, /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizRoundOverview["default"].answerContainer,
          dangerouslySetInnerHTML: {
            __html: _StringHelper["default"].removeLeadingAndTrailingBrAndPInHtml(player2StateHTML)
          }
        }))));
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactPullToRefresh["default"], {
        onRefresh: this.pullToRefresh,
        distanceToRefresh: 50,
        style: {
          textAlign: 'center',
          height: '100%',
          overflowY: 'hidden',
          paddingBottom: 80,
          resistence: 10
        }
      }, this.props.showBackButton && /*#__PURE__*/_react["default"].createElement("div", {
        className: _Quiz["default"].innerHeader
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _Quiz["default"].backButton,
        style: dynamicStyles.backButtonStyle,
        onClick: this.props.onBack
      }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowLeft["default"], {
        style: {
          fontSize: '30px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: _Quiz["default"].backText
      }, (0, _QuizStrings.getString)('BACK')))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_QuizRoundOverview["default"].overviewContainer, " ").concat(_DeviceInfoHelper["default"].isBrowser() ? _QuizRoundOverview["default"].browser : ''),
        style: {
          paddingTop: '2%'
        }
      }, this.renderHeader(scores, dynamicStyles), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizRoundOverview["default"].rowContainer
      }, roundsDisplayed), this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].finished ? this.renderFinalStatus(scores) : '')), this.renderFooter(ratio));
    }
  }]);
  return QuizRoundOverview;
}(_DataStoreComponent2["default"]);

exports["default"] = QuizRoundOverview;
QuizRoundOverview.propTypes = {
  onSetOpponent: _propTypes["default"].func.isRequired,
  onNextRound: _propTypes["default"].func.isRequired,
  onGoHome: _propTypes["default"].func.isRequired,
  onBack: _propTypes["default"].func.isRequired,
  getAuthToken: _propTypes["default"].func.isRequired,
  showBackButton: _propTypes["default"].bool,
  tournamentMode: _propTypes["default"].bool,
  runsInKesi: _propTypes["default"].bool,
  onRoundComplete: _propTypes["default"].func.isRequired
};
QuizRoundOverview.defaultProps = {
  showBackButton: true
};